import styled from 'styled-components';
import { ChildId } from 'types';
import { useMemo } from 'react';
import { useAppQuery } from '../../../../services/reactQuery/useAppQuery';
import ParentHTTPService from '../../../../services/HTTPService/parent/ParentHTTPService';
import { ParentAdditionalCostPackage } from './ParentAdditionalCostPackage/ParentAdditionalCostPackage';
import { EmptyDisplay } from '../../../molecules';

type Props = {
    period: string;
    childId: ChildId;
};

const BillListContainer = styled('div')`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
`;

export const ParentAdditionalCostList = ({ period, childId }: Props) => {
    const { data: additionalCostsSettlementData } = useAppQuery(
        'ADDITIONAL_COST_LIST',
        [period, childId],
        () =>
            ParentHTTPService.settlements.getAdditionalCostsSettlement({
                period,
            }),
        {},
    );

    const data = useMemo(
        () => (additionalCostsSettlementData?.additionalCostSummaryDtos ?? []).reverse(),
        [additionalCostsSettlementData],
    );

    const size = useMemo(() => data.length, [data]);

    if (size === 0) {
        return <EmptyDisplay emptyInfo="Brak dodatkowych kosztów w tym miesiącu" />;
    }

    return (
        <BillListContainer>
            {data.map((item, index) => {
                const { detailsDto, corrections } = item;

                return (
                    <ParentAdditionalCostPackage
                        childId={childId}
                        detailsDto={detailsDto}
                        corrections={corrections}
                        index={size - index - 1}
                    />
                );
            })}
        </BillListContainer>
    );
};
